/**
 * Short, neutral label for a model error string. Used in the retry-attempt
 * dropdown menu (e.g. "Attempt 1 · 429 rate limit"). Keep wording
 * informational; avoid alerting language ("failure", "error", "warning").
 */
export function summarizeModelError(err: string | null | undefined): string {
  if (!err) return "error";
  const s = err.trim();
  const lower = s.toLowerCase();

  if (/\b429\b/.test(s) || lower.includes("rate limit"))
    return "429 rate limit";
  if (lower.includes("timeout") || lower.includes("timed out"))
    return "timeout";
  if (lower.includes("context length") || lower.includes("too long"))
    return "context length";
  if (
    lower.includes("api key") ||
    lower.includes("unauthorized") ||
    lower.includes("authentication") ||
    /\b401\b/.test(s) ||
    /\b403\b/.test(s)
  )
    return "auth error";
  if (/\b5\d{2}\b/.test(s)) return "5xx error";
  if (/\b4\d{2}\b/.test(s)) return "4xx error";
  if (lower.includes("connection")) return "connection error";

  const first = s.split(/[\n.:]/)[0] ?? s;
  return first.length > 40 ? first.slice(0, 37) + "…" : first;
}
